module.exports = __webpack_public_path__ + "img/data_dui.07a160e6.png";